import React,{useState} from 'react'
import {HiMenuAlt4,HiX} from 'react-icons/hi'
import {motion} from 'framer-motion'
import { useTranslation} from "react-i18next";

import {images} from '../../constants'
import {Dropdown,DropdownItem, DropDownMenu} from '../Dropdown/Dropdown';
import { ReactComponent as GlobeIcon } from '../../assets/globe.svg';
import { ReactComponent as BellIcon } from '../../assets/bell.svg';
import { ReactComponent as PlusIcon } from '../../assets/plus.svg';
import './Navbar.scss'

const Navbar = () => {
  const { t } = useTranslation();
  const [toggle, setToggle] = useState(false)
  const [open, setOpen] = useState(false)
  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.logo} alt="logo"/>
      </div>
      <ul className='app__navbar-links'>
        {['home','about','projects','skills','testimonials','contact'].map((item)=> (
          <li className='app__flex p-text'key={`link-${item}`}>
            <div/>
            <a href={`#${item}`}>{t(`${item}`)}</a>
          </li>
        ))}
      </ul>

      <Dropdown>
        <DropdownItem open={open} setOpen={setOpen} icon={<PlusIcon/>}/>
        <DropdownItem open={open} setOpen={setOpen} icon={<BellIcon/>}/>
        <DropdownItem open={open} setOpen={setOpen} icon={<GlobeIcon/>}>
          <DropDownMenu setOpen={setOpen}></DropDownMenu>
        </DropdownItem>
      </Dropdown>

      <div className='app__navbar-menu'>
          <HiMenuAlt4 onClick={()=> setToggle(true)}/>

          {toggle && (

            <motion.div
           whileInView={{x:[300,0]}}
           transition={{duration:0.85, ease:'easeOut'}}
            >
             <HiX onClick={()=> setToggle(false)}/>
             <ul >
             {['home','about','projects','skills','testimonials','contact'].map((item)=> (
          <li key={`${item}`}>
            <a href={`#${item}`} onClick={()=> setToggle(false)}>{t(`${item}`)}</a>
          </li>
        ))}
        </ul>
            </motion.div>

          ) }
      </div>
    </nav>
  )
}

export default Navbar

function NavItem (props) {
<li className='app__navbar-item'>
<a href="#">{props.icon}</a>
</li>
}